export { default } from './global-error-page'
